import { render, staticRenderFns } from "./ChangeLogoButton.vue?vue&type=template&id=51ad0f55"
import script from "./ChangeLogoButton.vue?vue&type=script&lang=js"
export * from "./ChangeLogoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports